import { render, staticRenderFns } from "./NotificationManagement.vue?vue&type=template&id=3dab4d8f&lang=pug"
import script from "./NotificationManagement.vue?vue&type=script&lang=ts"
export * from "./NotificationManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports